import React from 'react';

/** Lucide-style line icons for the feed (the prototype's MoreHorizontal, Flag, Ban, Send, Smile, Trash). */

const Icon = ({ children }: { children: React.ReactNode }) => (
    <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="size-4 shrink-0"
    >
        {children}
    </svg>
);

export const DotsIcon = () => (
    <Icon>
        <circle cx="5" cy="12" r="1" />
        <circle cx="12" cy="12" r="1" />
        <circle cx="19" cy="12" r="1" />
    </Icon>
);

export const FlagIcon = () => (
    <Icon>
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
        <path d="M4 22v-7" />
    </Icon>
);

export const BlockIcon = () => (
    <Icon>
        <circle cx="12" cy="12" r="10" />
        <path d="m4.9 4.9 14.2 14.2" />
    </Icon>
);

export const SendIcon = () => (
    <Icon>
        <path d="M22 2 11 13" />
        <path d="M22 2 15 22l-4-9-9-4z" />
    </Icon>
);

export const SmileIcon = () => (
    <Icon>
        <circle cx="12" cy="12" r="10" />
        <path d="M8 14s1.5 2 4 2 4-2 4-2" />
        <path d="M9 9h.01M15 9h.01" />
    </Icon>
);

export const TrashIcon = () => (
    <Icon>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6" />
    </Icon>
);

export const ChevronIcon = () => (
    <Icon>
        <path d="m9 18 6-6-6-6" />
    </Icon>
);
